export default defineNuxtRouteMiddleware(to => {
  const ats = useAts(to)

  if (!ats.value?.isAts) {
    return navigateTo({ path: '/' })
  }
})
